import { FormControl, FormGroup } from '@angular/forms';
import { PropertyMetadata } from '../../../properties/property-types';
import { RegisterElement } from '../../element-decorator';
import { PolygonMapItem } from '../polygon-map-item';

@RegisterElement()
export class Ramp extends PolygonMapItem {
    public override TypeName: string = "Ramp";
    public override ParentType: string | null = null;
    public override ParentFormGroupName: string | null = "MapItems";

    constructor(formGroup: FormGroup) {
        super(formGroup, "Ramp");
        
        if (!formGroup.contains('Name')) {
            formGroup.addControl('Name', new FormControl(''));
        }
        if (!formGroup.contains('Width')) {
            formGroup.addControl('Width', new FormControl(3.5)); // 3.5m default width
        }
        if (!formGroup.contains('Length')) {
            formGroup.addControl('Length', new FormControl(12)); // 12m default length
        }
        if (!formGroup.contains('Slope')) {
            formGroup.addControl('Slope', new FormControl(15)); // 15% default slope
        }
        if (!formGroup.contains('Direction')) {
            formGroup.addControl('Direction', new FormControl('up'));
        }
        
        if(formGroup.contains('StrokeColor'))
            this.OutlineColor = '#' + formGroup.get('StrokeColor')?.value;
        else
            this.OutlineColor = "#777777";
        if(formGroup.contains('FillColor'))
            this.FillColor = '#' + formGroup.get('FillColor')?.value;
        else
            this.FillColor = "#888888";
    }

    public override getPropertyMetadata(): PropertyMetadata[] {
        return [
            {
                formControlName: 'Name',
                displayName: 'Ramp Name',
                inputType: { type: 'text' },
                order: 1,
                category: 'General'
            },
            {
                formControlName: 'Width',
                displayName: 'Width',
                inputType: { 
                    type: 'dimension',
                    unit: 'meters'
                },
                order: 2,
                category: 'Dimensions'
            },
            {
                formControlName: 'Length',
                displayName: 'Length',
                inputType: { 
                    type: 'dimension',
                    unit: 'meters'
                },
                order: 3,
                category: 'Dimensions'
            },
            {
                formControlName: 'Slope',
                displayName: 'Slope',
                inputType: { 
                    type: 'number',
                    min: 0,
                    max: 20,
                },
                description: 'Slope percentage (max 20%)',
                order: 4,
                category: 'Properties'
            },
            {
                formControlName: 'Direction',
                displayName: 'Direction',
                inputType: { 
                    type: 'select',
                    options: [
                        { value: 'up', label: 'Up' },
                        { value: 'down', label: 'Down' }
                    ]
                },
                order: 5,
                category: 'Properties'
            }
        ];
    }

    public override default(): Ramp {
        const width = this.formGroup.get('Width')?.value || 3.5;
        const length = this.formGroup.get('Length')?.value || 12;
        
        this.points = [
            { x: 0, y: 0 },
            { x: width, y: 0 },
            { x: width, y: length },
            { x: 0, y: length }
        ];
        return this;
    }

    public override clone(): Ramp {
        return new Ramp(this.formGroup);
    }

} 
